import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
declare global {
  interface Window {
    fbq: any;
  }
}
interface CTAButtonProps {
  text?: string;
  onClick?: () => void;
  className?: string;
}
export function CTAButton({
  text = 'DESCARGAR MI GUÍA AHORA',
  onClick,
  className = ''
}: CTAButtonProps) {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    // Fire Meta Pixel AddToCart event
    if (typeof window !== 'undefined' && window.fbq) {
      window.fbq('track', 'AddToCart', {
        content_name: 'Guía Mundial 2026',
        content_ids: ['44884317765741'],
        content_type: 'product',
        value: 6.39,
        currency: 'USD'
      });
    }
    // Call custom onClick if provided
    if (onClick) {
      onClick();
    }
  };
  return <div className={`relative group inline-block ${className}`} data-id="element-35">
      {/* Animated glow effect behind the button */}
      <motion.div className="absolute -inset-1 bg-gradient-to-r from-gold-400 to-gold-600 rounded-lg blur opacity-40 group-hover:opacity-75 transition duration-500" animate={{
      scale: [1, 1.02, 1],
      opacity: [0.4, 0.6, 0.4]
    }} transition={{
      duration: 2,
      repeat: Infinity,
      ease: 'easeInOut'
    }} data-id="element-36" />

      <motion.a href="https://moviverso.com/cart/44884317765741:1" target="_blank" rel="noopener noreferrer" onClick={handleClick} whileHover={{
      scale: 1.02
    }} whileTap={{
      scale: 0.98
    }} className="relative flex items-center justify-center gap-3 w-full sm:w-auto px-8 py-4 bg-gradient-to-b from-gold-400 to-gold-600 text-navy-950 font-heading font-bold text-xl uppercase tracking-wide rounded-lg shadow-[0_0_20px_rgba(212,168,67,0.3)] border border-gold-300/50 transition-all cursor-pointer" data-id="element-37">
        <span data-id="element-38">{text}</span>
        <ArrowRightIcon className="w-6 h-6" data-id="element-39" />
      </motion.a>
    </div>;
}